// @flow

import * as types from '../actionTypes';
import {
  createActionBundleForMany,
  createActionBundleForSingle,
} from '../utils';

export const getMyOfferingActions = createActionBundleForSingle(
  types.GET_MYOFFERING_ASYNC,
);
export const getMyOfferingListActions = createActionBundleForMany(
  types.GET_MYOFFERING_ASYNC,
);
